<gala-filtre (display)="showFiltre($event)" />

<div class="filtre" [hidden]="boFiltreHide">
    <ul>
        <li class="titre">{{translate.instant("FILTER")}}</li>
        <li>
            <select-filtre #selectActif [options]="filtreActif" (selected)="filtrer()" [placeholder]="lgTrad.ACTIFUL"
                optSorted="DESC" />
        </li>
        <li>
            <select-filtre #selectHorsZone [options]="filtreHorsZone" (selected)="filtrer()"
                [placeholder]="lgTrad.HORSZONE" optSorted="DESC" />
        </li>
        <li>
            <select-filtre #selectService [options]="filtreService" (selected)="filtrer()"
                [placeholder]="lgTradFiltre.SERVICE" optSorted="ASC" />
        </li>
        <li>
            <select-filtre #selectOrganisme [options]="filtreOrganisme" (selected)="filtrer()"
                [placeholder]="lgTradFiltre.ORGANISME" optSorted="ASC" />
        </li>
        <li>
            <select-filtre #selectServActif [options]="filtreServActif" (selected)="filtrer()"
                [placeholder]="translate.instant('APPCLIENT.SERVACTIFS')" optSorted="DESC" />
        </li>
        <li>
            <select-filtre #selectServActif [options]="filtreTypeReferent" (selected)="filtrer()"
                [placeholder]="lgTradFiltre.TYPEREFERENT" optSorted="DESC" />
        </li>
    </ul>
    <div class="total">{{translate.instant("FILTERS.TOTAL")}}<span>{{ getListeFiltree().length }}</span></div>
</div>

<div>
    <div-info-agent #infosAgent [idAgent]=idAgent />
    <div class="d-flex justify-content-center">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th></th>
                    @for (head of headElements; track head) {
                    <th (click)="sortBy(head.tri)"
                        [ngClass]="(head.sortable)?'cursor-hand text-center':'text-center cursor-arrow'">
                        {{head.libelle}}&nbsp;@if (head.sortable) {
                        <cp-icon-sort [col]="sColTri === head.tri" [boo]=booAscendant />
                        }
                    </th>
                    }
                    <th></th>
                </tr>
            </thead>
            <tbody>
                @for (client of listeElementsAff; track client; let odd = $odd) {
                <tr [class]="(!odd)? 'odd' : 'even'">
                    <td>
                        @if (client.SERVICES != null && client.SERVICES.length>0) {
                        <div (click)="client.del=!client.del" class="cursor-hand">
                            @if (!client.del) {
                            <i class="fas fa-plus cursor-hand"></i>
                            } @else {
                            <i class="fas fa-minus"></i>
                            }
                        </div>
                        }
                    </td>
                    <td><menu-client [client]="client">{{ client.NUCHEP }}</menu-client></td>
                    <td><menu-client [client]="client">{{ client.NOM }}</menu-client></td>
                    <td>{{ client.CPVILLE}}</td>
                    <td>{{ client.CONTACT_NOMPRENOM}}</td>
                    <td>{{ client.CONTACT_TEL1 }}</td>
                    <td>@if (client.CONTACTS[0].MAIL !== '') {
                        <a href="mailto:{{ client.CONTACTS[0].MAIL }}">{{
                            client.CONTACTS[0].MAIL }}</a>
                        }
                    </td>
                    <td>{{ client.REFERENT.NOM }} {{ client.REFERENT.PRENOM }}</td>
                    <td>
                        <div class="btn-group w-100 justify-content-end">
                            <gala-btn title="{{translate.instant('APPCLIENT.INVENTAIRE')}}"
                                (click)="nouvellePage(1,client)">
                                <i class="fas fa-list-alt"></i>
                            </gala-btn>
                            @if (droitsAccess.write) {
                            <gala-btn title="{{translate.instant('APPCLIENT.SERVICES')}}"
                                [light]="(client.SERVICES == null || client.SERVICES.length>=0)"
                                (click)="openCreerService(client)">
                                <i class="fas fa-atom"></i>
                                <i class="fas fa-plus"></i>
                            </gala-btn>
                            }
                            <gala-btn title="{{translate.instant('APPCLIENT.ACTIVITE')}}" [disabled]="!this.accesSuiviActivite"
                                (click)="nouvellePage(3,client)">
                                <i class="fas fa-clipboard-check"></i>
                            </gala-btn>
                            @if (hasAccessFicheClient()) {
                            @if (droitsAccess.write) {
                            <gala-btn-edit (click)="nouvellePage(4,client)"
                                title="{{translate.instant('APPCLIENT.DONNECL')}}" />
                            } @else {
                            <gala-btn-search (click)="nouvellePage(4,client)"
                                title="{{translate.instant('APPCLIENT.DONNECL')}}" />
                            }
                            }
                        </div>
                    </td>
                </tr>
                <tr class="subitem" [hidden]="!client.del">
                    <td class="text-center align-top"><i class="fas fa-atom fa-2x m-1"></i></td>
                    <td colspan="8">
                        <table class="w-100 subitem">
                            <tr>
                                <th></th>
                                <th colspan="3">{{translate.instant('APPCLIENT.SERVICES')}}</th>
                                <th class="text-center">{{translate.instant("APPCLIENT.INTERLOCUTEUR")}}</th>
                                <th class="text-center">{{translate.instant("APPCLIENT.TEL1")}}</th>
                                <th>{{translate.instant("MAIL")}}</th>
                                <th class="text-center">{{translate.instant("APPCLIENT.AGENT")}}</th>
                                <th class="text-center">{{translate.instant("APPCLIENT.TEL1")}}</th>
                                <th>{{translate.instant("MAIL")}}</th>
                                <th></th>
                            </tr>
                            @for (service of client.SERVICES; track service) {
                            <tr>
                                <td class="text-center"><cp-icon-actif [debut]="service.DDEBUT" [fin]="service.DFIN" />
                                </td>
                                <td colspan="2">{{service.TYPESERVICE.SERVICE}}</td>
                                <td></td>
                                <td>{{service.CONTACT.NOM + " " + service.CONTACT.PRENOM}}</td>
                                <td class="text-center">
                                    @if (service.CONTACT.TELA != null && service.CONTACT.TELA.NUMERO != null) {
                                    <span>
                                        {{service.CONTACT.TELA.INDICATIF}} {{ service.CONTACT.TELA.NUMERO |
                                        phone:service.CONTACT.TELA.INDICATIF:'.'}}
                                    </span>
                                    }
                                </td>
                                <td>@if (service.CONTACT.MAIL !== '') {
                                    <a href="mailto:{{ service.CONTACT.MAIL }}">{{ service.CONTACT.MAIL }}</a>
                                    }
                                </td>
                                <td dirUtil [user]="service.AGENT">{{(service.AGENT && service.AGENT.NOM)?
                                    service.AGENT.PRENOM + " " + service.AGENT.NOM : ''}}</td>
                                <td class="text-center">
                                    @if (service.AGENT.TELA != null && service.AGENT.TELA.NUMERO != null) {
                                    <span>
                                        {{service.AGENT.TELA.INDICATIF}} {{ service.AGENT.TELA.NUMERO |
                                        phone:service.AGENT.TELA.INDICATIF:'.'}}
                                    </span>
                                    }
                                </td>
                                <td>@if (service.AGENT.MAIL !== '') {
                                    <a href="mailto:{{ service.AGENT.MAIL }}">{{
                                        service.AGENT.MAIL }}</a>
                                    }
                                </td>
                                <td>
                                    <div class="btn-group w-100 justify-content-end">
                                        @if (droitsAccess.write) {
                                        <gala-btn-edit (click)="editService(service,client)" />
                                        } @else {
                                        <gala-btn-search (click)="editService(service,client)" />
                                        }
                                        @if (droitsAccess.write) {
                                        <gala-btn-delete (click)="delService(service,client)" />
                                        }
                                    </div>
                                </td>
                            </tr>
                            }
                        </table>
                    </td>
                </tr>
                }
            </tbody>
        </table>

    </div>

    <paginator />
